<ion-card>
  <ion-card-content>
    <div>
      <fa-icon [icon]="faMapMarkerAlt" class="warning"> </fa-icon>
      <span class="heure">{{
        'mainCourante.positionDeclared' | translate: { formattedTime: (declaration().instant.toDate() | date: 'HH:mm') }
      }}</span>
    </div>
  </ion-card-content>
</ion-card>
